// Import Swiper and its modules
// https://swiperjs.com/swiper-api#styles if you need to change the styles
import Swiper from 'swiper';
import {
  FreeMode,
  Autoplay,
  Navigation,
  Pagination,
  EffectFade,
} from 'swiper/modules';

// import 'swiper/css';

// import 'swiper/css/autoplay';
// import 'swiper/css/free-mode';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/effect-fade';

Swiper.use([Navigation, Pagination, FreeMode, Autoplay, EffectFade]);

// Social Feed Slider
document.querySelectorAll('.social-feed-slider').forEach(function (element) {
  const swiperContainer = element.querySelector('.swiper-container');

  if (!swiperContainer) return;

  new Swiper(swiperContainer, {
    grabCursor: true,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1.4,
    spaceBetween: -20, // Negatieve waarde voor overlap
    watchOverflow: true,
    breakpoints: {
      576: {
        slidesPerView: 2.2,
        spaceBetween: -25,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: -30,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: -35,
      },
      1400: {
        slidesPerView: 5,
        spaceBetween: -40,
      },
    },
    pagination: {
      el: element.querySelector('.social-feed-slider__pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: element.querySelector('.social-feed-slider__next'),
      prevEl: element.querySelector('.social-feed-slider__prev'),
    },
  });

  // Video autoplay on view (Intersection Observer)
  const videos = element.querySelectorAll('video[data-autoplay-on-view]');

  if (videos.length > 0 && 'IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.play().catch(() => {
              // Autoplay blocked, dat is ok
            });
          } else {
            entry.target.pause();
          }
        });
      },
      {
        threshold: 0.5, // 50% zichtbaar
      },
    );

    videos.forEach((video) => {
      videoObserver.observe(video);
    });
  }
});

// Hero Slider
document.querySelectorAll('.hero-slider').forEach(function (element) {
  const swiperContainer = element.querySelector('.swiper-container');

  if (!swiperContainer) return;

  const slides = swiperContainer.querySelectorAll('.swiper-slide');

  // Alleen initialiseren als er slides zijn
  if (slides.length === 0) return;

  new Swiper(swiperContainer, {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 800,
    loop: slides.length > 1,
    autoplay:
      slides.length > 1
        ? {
            delay: 6000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
    grabCursor: false,
    allowTouchMove: false, // Voorkom dat tekst selectie de slider breekt
    watchOverflow: true,
    pagination: {
      el: element.querySelector('.hero-slider__pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: element.querySelector('.hero-slider__next'),
      prevEl: element.querySelector('.hero-slider__prev'),
    },
    on: {
      // Reset Ken Burns animatie bij slide change
      slideChangeTransitionStart: function () {
        const activeSlide = this.slides[this.activeIndex];
        const img = activeSlide.querySelector('.hero-slide__image img');
        if (img) {
          img.style.animation = 'none';
          img.offsetHeight; // Trigger reflow
          img.style.animation = 'kenBurns 8s ease-out forwards';
        }
      },
    },
  });
});

// Infinite Logo Slider
new Swiper('.infinite-logo-slider', {
  freeMode: {
    enabled: true,
    momentum: false,
  },
  loop: true,
  allowTouchMove: true,
  slidesPerView: 3,
  spaceBetween: 24,
  autoplay: {
    delay: 0,
    disableOnInteraction: true,
  },
  speed: 5500,
  breakpoints: {
    768: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 5,
    },
    1200: {
      slidesPerView: 6,
    },
  },
});

// Standard
document.querySelectorAll('.general-swiper').forEach(function (element) {
  new Swiper(element.querySelector('.swiper-container'), {
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    watchOverflow: true,
    pagination: {
      el: '.general-pagination',
    },
    navigation: {
      nextEl: element.querySelector('.swiper-button-next'),
      prevEl: element.querySelector('.swiper-button-prev'),
    },
  });
});

// News
document.querySelectorAll('.news-swiper').forEach(function (element) {
  new Swiper(element.querySelector('.swiper-container'), {
    grabCursor: true,
    slidesPerView: 1.15,
    spaceBetween: 20,
    watchOverflow: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
    pagination: {
      el: element.querySelector('.news-pagination'),
    },
    navigation: {
      nextEl: element.querySelector('.swiper-button-next'),
      prevEl: element.querySelector('.swiper-button-prev'),
    },
  });
});

// Testimonials
document.querySelectorAll('.testimonial-swiper').forEach(function (element) {
  new Swiper(element.querySelector('.swiper-container'), {
    grabCursor: true,
    slidesPerView: 1.2,
    spaceBetween: 20,
    watchOverflow: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
    pagination: {
      el: '.testimonial-pagination',
    },
    navigation: {
      nextEl: element.querySelector('.swiper-button-next'),
      prevEl: element.querySelector('.swiper-button-prev'),
    },
  });
});

// Team
document.querySelectorAll('.team-swiper').forEach(function (element) {
  new Swiper(element.querySelector('.swiper-container'), {
    grabCursor: true,
    slidesPerView: 1.25,
    spaceBetween: 15,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
    pagination: {
      el: element.querySelector('.team-pagination'),
    },
    navigation: {
      nextEl: element.querySelector('.swiper-button-next'),
      prevEl: element.querySelector('.swiper-button-prev'),
    },
  });
});

// USPS
new Swiper('.usps-swiper', {
  grabCursor: true,
  slidesPerView: 1,
  spaceBetween: 15,
  breakpoints: {
    1024: {
      slidesPerView: 4,
      spaceBetween: 22,
    },
  },
});
